__turbopack_context__.v({
  "actionButton": "PH8UQq_actionButton",
  "date": "PH8UQq_date",
  "description": "PH8UQq_description",
  "descriptionTarget": "PH8UQq_descriptionTarget",
  "fileName": "PH8UQq_fileName",
  "fileRow": "PH8UQq_fileRow",
  "iconGroup": "PH8UQq_iconGroup",
  "metaRow": "PH8UQq_metaRow",
  "minimalMain": "PH8UQq_minimalMain",
  "root": "PH8UQq_root",
  "separatorDot": "PH8UQq_separatorDot",
  "textColumn": "PH8UQq_textColumn",
});
